import { useMemo } from 'react';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { AccountDataSelectors, createAccountDataSelectors } from 'application/store/slices/accountSlice/dataSelectors';
import { useApolloTypedClient } from 'application/providers/StoreProvider';

const selectorsCache = new WeakMap<
  ApolloClient<NormalizedCacheObject>,
  ReturnType<typeof createAccountDataSelectors>
>();

export const useAccountSelectors = (): AccountDataSelectors => {
  const apolloClient = useApolloTypedClient();

  return useMemo(() => {
    if (selectorsCache.has(apolloClient)) {
      return selectorsCache.get(apolloClient)!;
    }

    const selectors = createAccountDataSelectors(apolloClient);

    selectorsCache.set(apolloClient, selectors);

    return selectors;
  }, [apolloClient]);
};
